import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UserAddModelComponent } from '../user-add-model/user-add-model.component';
import { Router } from '@angular/router';
import { ApiService } from '../../../core/api.service';
import { UtilityService } from '../../../core/global/utility.service';
import { FunctionsService } from '../../../core/global/functions.service';
import { Lightbox } from 'ngx-lightbox';
import {  UploadCsvModalComponent} from "../../upload-csv-modal/upload-csv-modal.component";
import { CONFIG } from 'src/app/core/config';
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.sass']
})
export class UserComponent implements OnInit {
  gateList = [];
  deleteID = '';
  modalConfirmation;
  searchInput: any = '';
  sortedtby: any = 'id';
  page: number = 1;
  p;
  password
  pass
  userType: string;
  count: any;
  limit: any;
  totalPages: any=[];
  last: any;
  constructor( private modalService: NgbModal, private _adminService: ApiService, private _utility: UtilityService,private _function:FunctionsService, private _lightbox: Lightbox) { }
  ngOnInit(): void {
    this.userType = localStorage.getItem('m_ind_type');
    this.getUser();
  }
  getUser() {
    let url = "qr/user_list";
    let data = { searchText: this.searchInput, sortby: this.sortedtby, page: this.page };
    this._utility.showLoader();
    this._adminService.post(url, data).subscribe((response) => {
      this._utility.hideLoader();
      if (response.status == 200) {
        this.gateList = response.data;
        this.count = response.total;
        this.limit = response.limit;
        for (var j = 0; j < response.pages; j++) {
          this.totalPages[j] = j + 1;
        }
        this.last = response.pages;
      } else {
        this._utility.toastError(response.message);
      }
    })
  }
  paginate(page) {
    this.page = page;
    this.getUser();
  }
  openImage(src: string): void {
    // open lightbox3
    let data = [];
    data.push({ src: src, caption: '', thumb: src });
    this._lightbox.open(data, 0);
  }

  orgModal(Id) {
    window.localStorage.setItem('pushUserId', Id);
    const modalRef = this.modalService.open(UserAddModelComponent, { centered: true, backdrop: "static", size: 'xl' }); // xl, lg , sm
    modalRef.result.then(async(result) => {
      setTimeout(() => {
         this.getUser();
        
      }, 500);
    }, (reason) => {
      //
    });
  }
  importData(){
    const modalRef = this.modalService.open(UploadCsvModalComponent, { centered: true, backdrop: "static",size: 'm' }); // xl, lg , sm
    modalRef.componentInstance.endPoint='users/qr-user-upload'
    modalRef.result.then((result) => {
      this.getUser();
    }, (reason) => {
      
    });
  }
  exportData(){
    let url='qr/user_export'
    this._adminService.get(url).subscribe((response) => {
      if (response.status == 200) {
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', CONFIG.API_ENDPOINT + 'public/user/Users.csv');
        link.setAttribute('download', `Users.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();

      } else {
        this._utility.toastError(response.message);
      }
    })
  }
  confirmModal(content, id) {
    this.deleteID = id;
    this.modalConfirmation = this.modalService.open(content, { centered: true });
    this.modalConfirmation.result.then((result) => {
      //this.getGate('');
    }, (reason) => {
      //
    });
  }

  closeconfirm(param, id) {
    if (param == 'yes') {
      let url = 'qr/user_remove';
      let data = { 'id': this.deleteID }
      this._adminService.delete(url, data).subscribe((response) => {
        //this.spinnerService.hide();
        if (response.success == true) {
          this.getUser();
          this._utility.toastSuccess(response.message);
        } else {
          this._utility.toastError(response.message);
        }
        this.modalConfirmation.close();
      })
    } else {
      this.modalConfirmation.close();
    }
  }
  searchChanged(){
    this.page = 1;
    this.getUser();
   
  }
}
